import { ErrorBoundary } from 'react-error-boundary';
import ErrorContainer from '../../components/error-boundary/index';
import DpSearch from '../../components/dinner-party-search/index';

const DinnerPartySearch = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorContainer} onReset={() => {}}>
      <DpSearch />
    </ErrorBoundary>
  );
};
export default DinnerPartySearch;
